export default __webpack_public_path__ + "static/mmaieru-fc8f52f68b329b9333b6b24bd1c5b79c.jpg";